import { createContext } from 'react'

const OpponentContext = createContext(null)

export default OpponentContext;